import ActionTypes from '../constants'
import { LevelDefinitionActions, LevelsState } from '../models'

const deleteLevelDefinitionHandler = (
  state: LevelsState,
  action: LevelDefinitionActions,
): LevelsState => {
  switch (action.type) {
    case ActionTypes.DELETE:
      return {
        ...state,
        isLoading: true,
      }

    case ActionTypes.DELETE_SUBSCRIBER:
      return {
        ...state,
        isLoading: false,
        levels: state.levels.filter(
          level => level.id !== action.payload.message,
        ),
      }

    default:
      return state
  }
}

export default deleteLevelDefinitionHandler
